import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=2922705c"
import script from "./ClipboardCopy.vue?vue&type=script&lang=ts"
export * from "./ClipboardCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports